import Login from './login';
import './login.scss';

export default Login;